import { render, staticRenderFns } from "./LeagueViewer.vue?vue&type=template&id=556c40cf&"
import script from "./LeagueViewer.vue?vue&type=script&lang=js&"
export * from "./LeagueViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports